// extracted by mini-css-extract-plugin
module.exports = {"dotNavSelector":"styles_dotNavSelector__15-dx","current":"styles_current__3ng-B"};